var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64294 7.14288L4.42678 5.92672C4.26929 5.76923 4 5.88077 4 6.1035V9.74995C4 9.88802 4.11193 9.99995 4.25 9.99995H7.89645C8.11917 9.99995 8.23071 9.73066 8.07322 9.57317L6.715 8.21495C7.89508 6.57016 9.82314 5.49997 12.0001 5.49997C15.5899 5.49997 18.5001 8.41012 18.5001 12C18.5001 15.5899 15.5899 18.5 12.0001 18.5C8.63773 18.5 5.87085 15.9464 5.53446 12.6733C5.49211 12.2612 5.12376 11.9615 4.71171 12.0039C4.29967 12.0462 3.99997 12.4146 4.04232 12.8266C4.45652 16.8569 7.86076 20 12.0001 20C16.4183 20 20.0001 16.4183 20.0001 12C20.0001 7.58169 16.4183 3.99997 12.0001 3.99997C9.40771 3.99997 7.10436 5.23298 5.64294 7.14288ZM11.75 7.99997C12.1642 7.99997 12.5 8.33576 12.5 8.74997V11.7422L14.5285 12.5536C14.9131 12.7074 15.1002 13.1439 14.9464 13.5285C14.7925 13.9131 14.356 14.1002 13.9715 13.9463L11.4715 12.9463C11.1867 12.8324 11 12.5566 11 12.25V8.74997C11 8.33576 11.3358 7.99997 11.75 7.99997Z",
    fill: "#647593"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.da613254766847a98dc11314eb6a2a23.svg";
export { ForwardRef as ReactComponent };